import React, { useEffect, useState } from "react";
import PointRequestService from "../services/PointRequestService";
import { Modal } from 'react-bootstrap';
import Table from "../component/Tables/Table";
import PaginationComponent from "../component/Common/PaginationComponent";
import { toast } from "react-toastify";

const PointRequest = () => {

    const [pointRequest, setPointRequest] = useState([]);
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(0);
    const [totalPages, setTotalPages] = useState(0)
    const [size, setSize] = useState(15);
    const [showRemarksModal, setShowRemarksModal] = useState(false);
    const [remarks, setRemarks] = useState("");
    const [selectedId, setSelectedId] = useState(null);

    useEffect(() => {
        fetchPointRequest();
    }, [currentPage]);

    const fetchPointRequest = async () => {
        setLoading(true);
        setPointRequest([]);
        const storedUser = JSON.parse(localStorage.getItem('user'));
        const token = storedUser?.token;
        try {
            const response = await PointRequestService.getAllPointRequestPages(currentPage, size, token);
            setPointRequest(response.content);
            setTotalPages(response.totalPages);
        } catch (error) {
            toast.error("Failed To Fetch!")
            console.error('Error', error);
            setPointRequest([]);
        } finally {
            setLoading(false);
        }
    };

    const handleReject = async () => {
        if (!remarks.trim()) {
            toast.error("Please enter remarks before rejecting.");
            return;
        }
        const storedUser = JSON.parse(localStorage.getItem('user'));
        const token = storedUser?.token;
        try {
            await PointRequestService.rejectPointRequest(selectedId, remarks, token);
            // Refresh data after rejected
            fetchPointRequest();
            toast.success('Point Request Rejected');
        } catch (error) {
            toast.error(error)
            console.error(error);
        } finally {
            handleCloseModal();
        }
    };

    const handleVerify = async (item) => {
        const confirmAction = window.confirm(`Are you sure you want to verify the Point Request?`);
         if (!confirmAction) {
            // User canceled the action
            return;
        }
        const storedUser = JSON.parse(localStorage.getItem('user'));
        const token = storedUser?.token;
        try {
            await PointRequestService.verifyPointRequest(item.id, token);
            // Refresh data after verified
            fetchPointRequest();
            toast.success('Point Request Verified');
        } catch (error) {
            toast.error(error)
            console.error(error);
        }
    };

    const handleOpenModal = (id) => {
        setSelectedId(id);
        setRemarks(""); // Reset remarks input
        setShowRemarksModal(true);
    };

    const handleCloseModal = () => {
        setShowRemarksModal(false);
        setRemarks("");
        setSelectedId(null);
    };

    const columns = ['id', 'userId', 'invoiceUrl', 'amount', 'rewardPoints', 'status', 'comment', 'verifiedAt', 'createdDate'];

    return (
        <>
            <div className='col-md-11 mt-2 mx-auto'>
                <div className='pointTable_title'><h2>Points Request</h2></div>
                <div className="points_table">
                <Table
                    data={pointRequest}
                    columnsToShow={columns}
                    onDelete={handleOpenModal}
                    onEdit={handleVerify}
                />
                </div>
                {totalPages > 1 && (
                    <PaginationComponent
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={(pageNumber) => setCurrentPage(pageNumber)}
                    />
                )}
            </div>

            {/* Bootstrap Modal for Reject Confirmation */}
            {showRemarksModal && (
                <Modal className='modal_style' show={showRemarksModal} onHide={handleCloseModal}>
                    <div className="modal-header">
                        <h5 className="modal-title">Reject Request</h5>
                        <button type="button" className="btn-close" onClick={handleCloseModal}></button>
                    </div>
                    <div className="modal-body pb-4">
                        <p className="text-left">Please enter remarks for rejecting this request:</p>
                        <textarea
                            className="form-control"
                            value={remarks}
                            onChange={(e) => setRemarks(e.target.value)}
                            placeholder="Enter remarks here..."
                        />
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={handleCloseModal}>
                            Cancel
                        </button>
                        <button type="button" className="btn btn-danger" onClick={handleReject}>
                            Reject
                        </button>
                    </div>
                </Modal>
            )}
        </>
    );
};

export default PointRequest;